import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import { CurrencyIdInput } from '@/pages/instruments/new-instrument/form-fields/CurrencyIdInput'

export interface CurrencyIdFieldProps {}

export const CurrencyIdField: React.FC<CurrencyIdFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ currency_id: number }>()

  return (
    <FormField
      name="currency_id"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2 overflow-hidden">
              <FormLabel>Currency</FormLabel>
              <FormError />
            </div>
            <CurrencyIdInput
              className={'flex flex-1 min-w-auto!'}
              placeholder={'Select a currency...'}
              value={value?.toString()}
              setValue={(value) =>
                setValue('currency_id', parseInt(value), { shouldValidate: true })
              }
            />
          </FormItem>
        )
      }}
    />
  )

  return <></>
}
